import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getGroupsForRoleById } from "../../actions/api";
import { useDispatch } from "react-redux";
import { SignatureOutlined } from "@ant-design/icons";
import { Modal } from "antd";

const RoleGroupsModal = ({
  // props
  visible,
  application,
  subscribedRole,
  groupForSubscription,

  // prop methods
  handleCancel,
  handleOk,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [roleGroup, setRoleGroup] = useState(null);

  // hooks
  useEffect(() => {
    const doSearch = async () => {
      setLoading(true);
      if (groupForSubscription) {
        setRoleGroup(groupForSubscription);
      } else {
        const groups = await dispatch(getGroupsForRoleById(subscribedRole.id));
        if (groups && groups.payload && groups.payload.data) {
          const filteredGroups = groups.payload.data.filter(
            (g) => g.selfSubscriptionType !== "Closed" && g.dynamic === false,
          );
          setRoleGroup(filteredGroups[0]);
        }
      }
      setLoading(false);
    };

    if (visible) {
      doSearch();
    }
  }, [
    dispatch,
    application,
    subscribedRole,
    setLoading,
    visible,
    groupForSubscription,
  ]);

  return (
    <Modal
      title="Subscribe"
      loading={loading}
      icon={<SignatureOutlined />}
      open={visible}
      onClose={handleCancel}
      onCancel={handleCancel}
      onOk={() => handleOk(roleGroup)}
    >
      <p>Do you want to subscribe to the following:</p>
      <ul>
        <li>{application.displayName}</li>
      </ul>
      <p>Note: It might take up to 15 minutes to be active and visible.</p>
    </Modal>
  );
};

RoleGroupsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  application: PropTypes.object.isRequired,
  subscribedRole: PropTypes.string.isRequired,
  groupForSubscription: PropTypes.string,
  // prop methods
  handleCancel: PropTypes.func.isRequired,
  handleOk: PropTypes.func.isRequired,
};

export default RoleGroupsModal;
